import { connect } from 'react-redux'
import { compose, lifecycle, withState, withHandlers, withProps } from 'recompose'
import { bindActionCreators } from 'redux'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as PlaybookActions from 'app/modules/playbook/actions'

import ConditionModal from './component'

const mapStateToProps = state => {
  const id = PlaybookSelectors.getCurrentConditionId(state)
  return {
    id,
    condition: PlaybookSelectors.getCondition(state, { id }),
    playbooks: PlaybookSelectors.emailPlaybooks(state),
    getPlaybookIdForCampaignId: (campaignId) => PlaybookSelectors.playbookIdForCampaignId(state, campaignId),
    getIsPlaybookIdForCampaignIdLoading: (campaignId) => PlaybookSelectors.playbookIdForCampaignIdLoading(state, campaignId),
    getIsPlaybookIdForCampaignIdFailed: (campaignId) => PlaybookSelectors.playbookIdForCampaignIdFailed(state, campaignId),
    getPlaybookIsPending: (playbookId) => PlaybookSelectors.getPlaybookIsPending(state, playbookId),
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setValue: PlaybookActions.setEmailPlaybookConditionValue,
    getPlaybook: PlaybookActions.getPlaybook,
    getPlaybookByCampaignId: PlaybookActions.getPlaybookByCampaignId,
    searchPlaybooks: PlaybookActions.searchPlaybooks,
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(props => {
    const playbookOptions = props.playbooks.map(playbook => ({ value: playbook.id, label: playbook.name })).toJS()
    try {
      const campaignId = parseInt(props.condition.value.first().split('=')[1])
      const selectedPlaybookId = props.getPlaybookIdForCampaignId(campaignId)
      if (!selectedPlaybookId && campaignId) {
        props.actions.getPlaybookByCampaignId({ campaignId })
      }

      return {
        campaignId,
        playbookOptions,
        selectedPlaybookId,
      }
    } catch(err) {
      // couldn't get the playbookId
      return {
        playbookOptions
      }
    }
  }),
  withState('selectedPlaybookId', 'setSelectedPlaybookId', props => props.selectedPlaybookId),
  withProps(props => ({
    isLoading: props.getPlaybookIsPending(props.selectedPlaybookId) || props.getIsPlaybookIdForCampaignIdLoading(props.campaignId)
  })),
  lifecycle({
    componentDidMount() {
      const { actions: { searchPlaybooks }} = this.props
      searchPlaybooks()
    }
  }),
  withHandlers({
    onValueChange: ({ id, setSelectedPlaybookId, actions: { setValue, getPlaybook }}) => value => {
      if (value) {
        getPlaybook({ playbookId: value.value, nextAction: (playbook) => setValue({ playbook, conditionId: id }) })
        setSelectedPlaybookId(value.value)
      } else {
        setSelectedPlaybookId(null)
      }
    },
  }),
)(ConditionModal)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailPlaybookSelect/index.js